/**
 * @generated SignedSource<<bbc422f9225395c4393d436a1495574e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventSignUpStatus = "CONFIRMED" | "DRAFT";
export type OrderStatus = "CANCELED" | "DRAFT" | "EMPTY" | "FULLY_PAID" | "FULLY_REFUNDED" | "OPEN" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED";
export type SquareLoyaltyRewardStatus = "DELETED" | "ISSUED" | "REDEEMED";
import { FragmentRefs } from "relay-runtime";
export type EventSignupSummaryContent_signUp$data = {
  readonly canDelete: boolean | null | undefined;
  readonly id: string;
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly availableLoyaltyRewards?: {
          readonly balance: number;
        } | null | undefined;
        readonly id: string;
        readonly loyaltyEnrollmentOffer?: {
          readonly points: number;
        } | null | undefined;
        readonly orderOwner?: {
          readonly id: string;
          readonly squareLoyaltyAccount: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
        readonly squareLoyaltyRewards?: ReadonlyArray<{
          readonly id: string;
          readonly loyaltyAccount: {
            readonly id: string;
          } | null | undefined;
          readonly loyaltyCustomerId: string | null | undefined;
          readonly points: number;
          readonly rewardTier: {
            readonly id: string;
            readonly name: string;
          };
          readonly status: SquareLoyaltyRewardStatus;
        }>;
        readonly status: OrderStatus | null | undefined;
        readonly total: number | null | undefined;
        readonly totalTaxes: number | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"PatronCheckoutLoyaltyRewardsEnrollmentOffer_order" | "PatronCheckoutLoyaltyRewards_order">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly registrations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly primaryChargeType: {
          readonly chargeRuleSet: {
            readonly chargeRules: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly price: number;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
          };
          readonly id: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly signUpWindow: {
    readonly cancelDeadlineAt: string | null | undefined;
  } | null | undefined;
  readonly status: EventSignUpStatus;
  readonly waitlistIndex: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryActions_signUp" | "EventSignupSummaryPaymentSummary_signUp" | "EventSignupSummaryPlayerList_signUp" | "EventSignupSummaryReservation_signUp" | "EventSignupSummaryTotal_signUp">;
  readonly " $fragmentType": "EventSignupSummaryContent_signUp";
};
export type EventSignupSummaryContent_signUp$key = {
  readonly " $data"?: EventSignupSummaryContent_signUp$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryContent_signUp">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v3 = [
  (v0/*: any*/)
],
v4 = [
  {
    "kind": "Variable",
    "name": "patronLoyalty",
    "variableName": "patronLoyalty"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSignupSummaryContent_signUp",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canDelete",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitlistIndex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "EventRegistrationConnection",
      "kind": "LinkedField",
      "name": "registrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventRegistrationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventRegistrationChargeType",
                  "kind": "LinkedField",
                  "name": "primaryChargeType",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ChargeRuleSet",
                      "kind": "LinkedField",
                      "name": "chargeRuleSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "first",
                              "value": 1
                            }
                          ],
                          "concreteType": "ChargeRuleConnection",
                          "kind": "LinkedField",
                          "name": "chargeRules",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ChargeRuleEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ChargeRule",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v0/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "price",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": "chargeRules(first:1)"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "registrations(first:50)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "active",
          "value": true
        }
      ],
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "total",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalTaxes",
                  "storageKey": null
                },
                {
                  "condition": "patronLoyalty",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderAvailableLoyaltyRewards",
                      "kind": "LinkedField",
                      "name": "availableLoyaltyRewards",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "balance",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderLoyaltyEnrollmentOffer",
                      "kind": "LinkedField",
                      "name": "loyaltyEnrollmentOffer",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Customer",
                      "kind": "LinkedField",
                      "name": "orderOwner",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SquareLoyaltyAccount",
                          "kind": "LinkedField",
                          "name": "squareLoyaltyAccount",
                          "plural": false,
                          "selections": (v3/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SquareLoyaltyReward",
                      "kind": "LinkedField",
                      "name": "squareLoyaltyRewards",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        (v2/*: any*/),
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "loyaltyCustomerId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SquareLoyaltyAccount",
                          "kind": "LinkedField",
                          "name": "loyaltyAccount",
                          "plural": false,
                          "selections": (v3/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SquareLoyaltyRewardTier",
                          "kind": "LinkedField",
                          "name": "rewardTier",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PatronCheckoutLoyaltyRewards_order"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PatronCheckoutLoyaltyRewardsEnrollmentOffer_order"
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "orders(active:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSignUpWindow",
      "kind": "LinkedField",
      "name": "signUpWindow",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cancelDeadlineAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventSignupSummaryPlayerList_signUp"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventSignupSummaryTotal_signUp"
    },
    {
      "args": (v4/*: any*/),
      "kind": "FragmentSpread",
      "name": "EventSignupSummaryPaymentSummary_signUp"
    },
    {
      "args": (v4/*: any*/),
      "kind": "FragmentSpread",
      "name": "EventSignupSummaryReservation_signUp"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventSignupSummaryActions_signUp"
    }
  ],
  "type": "EventSignUp",
  "abstractKey": null
};
})();

(node as any).hash = "cbc2a2d5c334a08698b91801c2184ce4";

export default node;
